import React from 'react';
import styles from './spacer.module.scss';
export const Spacer = ({ node }) => {
  const { layout } = node;
  return <div className={layout === 1 ? styles.spacerOne : styles.spacer} />;
};
